import HTTPService    from "@/js/Shared/Services/HTTP/HTTPService";
import SAPOMailConfig from "@/SAPOMailConfig";

export {ClientLoggingHTTPService as default};

/**
 * @description Class responsible for managing
 * HTTP services for ClientLoggingController
 *
 * @author rsommerfeld <roni.s.sommerfeld@altice.pt>
 *
 * @since 7.0.0
 *
 * @private
 */
class ClientLoggingHTTPService {
  /**
   * Filters Endpoint
   *
   * @public
   *
   * @type {string}
   *
   * @since 7.0.0
   */
  endpoint = SAPOMailConfig.client.endpoints.logging.javascript;

  /**
   * creates the log on the server with base in error
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object.<ClientLoggingItem>} data_item
   *
   * @returns {Promise.<HTTPResponseEntity>}
   */
  async createLogError(data_item) {
    const request = {
      op: 'createLogError',
      data: data_item,
    };

    return await HTTPService.post(`${this.endpoint}/clientLogging`, request, null, false);
  }

  /**
   * creates the log on the server with base in warning
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object.<ClientLoggingItem>} data_item
   *
   * @returns {Promise.<HTTPResponseEntity>}
   */
  async createLogWarn(data_item) {
    const request = {
      op: 'createLogWarn',
      data: data_item,
    };

    return await HTTPService.post(`${this.endpoint}/clientLogging`, request, null, false);
  }
}